<template>
  <div
    :class="[
      'upsell-upgrade-cta flex flex-col items-center',
      { 'upsell-upgrade-cta--sticky': sticky },
    ]"
    :data-testid="sticky ? 'upsell-upgrade-cta-sticky' : 'upsell-upgrade-cta'"
  >
    <OwnButton
      class="upsell-upgrade-cta__button"
      :text="t('upsell.upgrade-cta-priced', { price })"
      variant="primary"
      data-testid="upsell-upgrade-cta-button"
      @click="emit('upgrade')"
    />
    <OwnType
      class="upsell-upgrade-cta__cancel"
      :text="t('upsell.cancel-any-time')"
      variant="paragraph-small"
      color="secondary"
    />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { OwnButton } from '@/ui/OwnButton'
import { OwnType } from '@/ui/OwnType'

import { useProUpsellContent } from '../composables/useProUpsellContent'

const emit = defineEmits<{
  upgrade: []
}>()

withDefaults(defineProps<{ sticky?: boolean }>(), { sticky: false })

const { t } = useI18n({ useScope: 'global' })

const { price } = useProUpsellContent()
</script>

<style lang="scss" scoped>
.upsell-upgrade-cta {
  gap: 6px;
  width: 100%;
  min-height: 72px;
  padding: 10px 24px 8px;

  .upsell-upgrade-cta__button {
    width: 100%;
    max-width: 326px;
    min-height: 40px;
    padding: 10px 24px;
    border-radius: 10px;
    background: #0d0e0e;

    :deep(.text-button-regular) {
      font-size: 0.875rem;
      line-height: 19.6px;
    }

    &:hover {
      background-color: #1b1d1c;
    }
  }

  &__cancel {
    font-size: 10px;
    line-height: 14px;
  }

  &--sticky {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 3;
    min-height: 200px;
    padding-top: 120px;
    background: linear-gradient(
      to bottom,
      rgb(255 255 255 / 0%),
      rgb(255 255 255 / 60%) 34%,
      rgb(255 255 255 / 88%) 50%,
      var(--white) 78%
    );
  }
}
</style>
